import type { paths } from '@omnea-app/permissions/permissionsHttpClient/permissionsGeneratedTypes'
import type { QueryClient } from '@tanstack/react-query'

/** The records with an access list: the permission-set entities, and documents. */
export type RecordAccessEntity = paths['/entities/{entity}/{recordId}/access']['get']['parameters']['path']['entity']

const RECORD_GRANTS_QUERY_KEY = 'GetRecordGrants'

export const recordGrantsQueryKey = (userId: string, entity: RecordAccessEntity, recordId: string) =>
  [RECORD_GRANTS_QUERY_KEY, userId, entity, recordId] as const

export const invalidateRecordGrants = (queryClient: QueryClient) =>
  queryClient.invalidateQueries({ queryKey: [RECORD_GRANTS_QUERY_KEY] })

export const cancelRecordGrants = (queryClient: QueryClient) => queryClient.cancelQueries({ queryKey: [RECORD_GRANTS_QUERY_KEY] })
